<template>
  <AppDialog
    title="Reset password"
    :show="show"
    append-to-body
    @close="close"
  >
    <form
      id="reset-password-dialog"
      @submit.prevent="onFormSubmit"
    >
      <h3 class="mt-0">{{ user.name }}</h3>

      <div class="d-inline-flex break-word align-items-center mb-10">
        <i class="hi hi-16 hi-mail text-lighter mr-10" />
        {{ user.email }}
      </div>

      <div class="footer">
        <div class="d-flex mt-40">
          <div class="ml-auto">
            <AppButton
              class="mr-15"
              type="default"
              @click="close"
            >
              Cancel
            </AppButton>

            <button
              class="btn btn-primary"
              type="submit"
              :disabled="submitting"
            >
              {{ sendLabel }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </AppDialog>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  name: 'MemberSendResetPasswordDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      submitting: false,
    };
  },
  computed: {
    ...mapState({
      membership: 'membership',
      user: (state) => state.membership.user,
    }),
    ...mapGetters(['organizationId']),
    sendLabel() {
      return this.submitting ? 'Sending...' : 'Send instructions';
    },
  },
  methods: {
    ...mapActions(['requestNewPassword']),
    close() {
      this.$emit('close');
    },
    onFormSubmit() {
      this.submitting = true;
      this.requestNewPassword({ organizationId: this.organizationId, userId: this.user.id }).then((response) =>
        this.completeRequest(response),
      );
    },
    completeRequest(response) {
      this.submitting = false;
      if (response.status === 'success') {
        this.$appMessage('Password reset email sent');
      } else {
        this.$appMessage(response.errors);
      }
      this.close();
    },
  },
};
</script>
